/* eslint-disable @typescript-eslint/naming-convention */
import type { TextElement } from '@studiobuki/web-core/lib/book-common';
import {
  AFSSerifGothic04trialE_ffffff_21,
  AFSSerifGothic04trialE_ffffff_31,
  APJapanesefont_000000_21,
  APJapanesefont_000000_23,
  APJapanesefont_000000_30,
} from './_styles';

const SEGMENT_0_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_0_text_1: TextElement = {
  align: 'center',
  style: AFSSerifGothic04trialE_ffffff_31,
  text: SEGMENT_0_text_value_1,
  width: 842,
  textPath: 'M 0 0 S 302 -100 604 0',
  x: 113,
  y: 170,
};
const SEGMENT_0_text_value_2 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_0_text_2: TextElement = {
  align: 'center',
  style: AFSSerifGothic04trialE_ffffff_21,
  text: SEGMENT_0_text_value_2,
  width: 842,
  textPath: 'M 0 0 S 302 210 604 0',
  x: 115,
  y: 441,
};

const SEGMENT_1_text_value_1 = '「{{heroName}}{{kidstitle}}」と';

export const SEGMENT_1_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_1_text_value_1,
  x: 410,
  y: 39,
};
const SEGMENT_1_text_value_2 = '{{heroName}}';
const SEGMENT_1_text_value_3 = '{{kidstitle}}';

export const SEGMENT_1_text_2_kun: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_30,
  text: SEGMENT_1_text_value_2,
  x: 305,
  y: 438,
  width: 150,
  rotation: -9,
};
export const SEGMENT_1_text_2_chan: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_30,
  text: SEGMENT_1_text_value_2,
  x: 305,
  y: 438,
  width: 150,
  rotation: -9,
};
export const SEGMENT_1_text_2_san: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_30,
  text: SEGMENT_1_text_value_2,
  x: 305,
  y: 438,
  width: 150,
  rotation: -9,
};
export const SEGMENT_1_text_2_nashi: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_30,
  text: SEGMENT_1_text_value_2,
  x: 259,
  y: 444,
  width: 285,
  rotation: -9,
};

export const SEGMENT_1_text_3_kun: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_1_text_value_3,
  x: 435,
  y: 426,
  width: 60,
  rotation: -9,
};
export const SEGMENT_1_text_3_chan: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_1_text_value_3,
  x: 442,
  y: 424,
  width: 60,
  rotation: -9,
};
export const SEGMENT_1_text_3_san: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_1_text_value_3,
  x: 435,
  y: 425,
  width: 60,
  rotation: -9,
};
export const SEGMENT_1_text_3_nashi: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_1_text_value_3,
  x: 237,
  y: 452,
  width: 285,
  rotation: -9,
};

const SEGMENT_3_text_value_1 = '{{heroName}}{{kidstitle}}がつぶやきました。';

export const SEGMENT_3_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_21,
  text: SEGMENT_3_text_value_1,
  x: 0,
  y: 120,
  width: 842,
};

const SEGMENT_5_text_value_1 = '「もちろん！」と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_5_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_21,
  text: SEGMENT_5_text_value_1,
  x: 445,
  y: 123,
  width: 316,
};

const SEGMENT_7_text_value_1 = '{{heroName}}{{kidstitle}}はかんがえました。';

export const SEGMENT_7_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_21,
  text: SEGMENT_7_text_value_1,
  x: 0,
  y: 70,
  width: 842,
};

const SEGMENT_10_text_value_1 =
  'こうして、{{heroName}}{{kidstitle}}といっしょに';

export const SEGMENT_10_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_10_text_value_1,
  x: 55,
  y: 235,
};

const SEGMENT_12_text_value_1 = '{{heroName}}{{kidstitle}}は';

export const SEGMENT_12_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_12_text_value_1,
  x: 165,
  y: 85,
};

const SEGMENT_12_text_value_2 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_12_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_12_text_value_2,
  x: 400,
  y: 433,
};
const SEGMENT_13_text_value_A = '{{heroName}}{{kidstitle}}」';
export const SEGMENT_13_text_1_A: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_23,
  text: SEGMENT_13_text_value_A,
  x: 586,
  y: 207,
};

const SEGMENT_13_text_value_B = '{{heroName}}{{kidstitle}}」';
export const SEGMENT_13_text_1_B: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_23,
  text: SEGMENT_13_text_value_B,
  x: 619,
  y: 206,
};

const SEGMENT_13_text_value_C = '{{heroName}}{{kidstitle}}」';

export const SEGMENT_13_text_1_C: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_23,
  text: SEGMENT_13_text_value_C,
  x: 551,
  y: 206,
};
const SEGMENT_13_text_value_D = '{{heroName}}{{kidstitle}}」';
export const SEGMENT_13_text_1_D: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_23,
  text: SEGMENT_13_text_value_D,
  x: 608,
  y: 206,
};

const SEGMENT_22_text_value_1 = '{{heroName}}{{kidstitle}}のがんばりのおかげで';

export const SEGMENT_22_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_22_text_value_1,
  x: 325,
  y: 28,
};

const SEGMENT_24_text_value_1 = '{{heroName}}{{kidstitle}}がむねをはります。';

export const SEGMENT_24_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_24_text_value_1,
  x: 30,
  y: 500,
};

const SEGMENT_27_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_27_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_27_text_value_1,
  x: 413,
  y: 93,
};

const SEGMENT_29_text_value_1 =
  '{{heroName}}{{kidstitle}}は、こっそりハイタッチしました。';

export const SEGMENT_29_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_29_text_value_1,
  x: 395,
  y: 526,
};

const SEGMENT_30_text_value_1 = '{{heroName}}{{kidstitle}}」';

export const SEGMENT_30_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_30_text_value_1,
  x: 190,
  y: 479,
};

const SEGMENT_30_text_value_2 = '{{heroName}}{{kidstitle}}もにっこり。';

export const SEGMENT_30_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_30_text_value_2,
  x: 305,
  y: 522,
};

const SEGMENT_32_text_value_1 =
  '{{heroName}}{{kidstitle}}はもうしっているかもしれないけれど。';
export const SEGMENT_32_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_32_text_value_1,
  x: 101,
  y: 52,
};

export const SEGMENT_33_text_value_1 = '[{{heroName}}]{{kidstitle}}のゆめの駅';

export const SEGMENT_34_text_value_1 = '[{{heroName}}]{{kidstitle}}';

export const SEGMENT_34_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_21,
  text: SEGMENT_34_text_value_1,
  x: 35,
  y: 497,
  width: 138,
};

const SEGMENT_99032_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_99032_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99032_text_value_1,
  x: 367,
  y: 433,
};

const SEGMENT_99033_text_value_1 =
  '{{heroName}}{{kidstitle}}はけんちくかさんに、こんなおねがいをしました。';

export const SEGMENT_99033_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99033_text_value_1,
  x: 201,
  y: 74,
};

const SEGMENT_99034_text_value_1 = '{{heroName}}{{kidstitle}}は';

export const SEGMENT_99034_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99034_text_value_1,
  x: 527,
  y: 88,
};

const SEGMENT_99035_text_value_1 = '{{heroName}}{{kidstitle}}が';

export const SEGMENT_99035_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99035_text_value_1,
  x: 625,
  y: 110,
};

const SEGMENT_99037_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_99037_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99037_text_value_1,
  x: 650,
  y: 444,
};

const SEGMENT_99038_text_value_1 = '{{heroName}}{{kidstitle}}はこたえました。';

export const SEGMENT_99038_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99038_text_value_1,
  x: 154,
  y: 519,
};

const SEGMENT_99039_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_99039_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99039_text_value_1,
  x: 224,
  y: 225,
};
export const SEGMENT_99039_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99039_text_value_1,
  x: 578,
  y: 485,
};

const SEGMENT_99040_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99040_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99040_text_value_1,
  x: -346,
  y: 150,
};

const SEGMENT_99041_text_value_1 = '{{heroName}}{{kidstitle}}は';

export const SEGMENT_99041_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99041_text_value_1,
  x: 615,
  y: 69,
};

const SEGMENT_99041_text_value_2 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99041_text_2: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99041_text_value_2,
  x: -668,
  y: 190,
  width: 842,
};

const SEGMENT_99041_text_value_3 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99041_text_3: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99041_text_value_3,
  x: -378,
  y: 333,
  width: 842,
};

const SEGMENT_99043_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99043_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99043_text_value_1,
  x: -490,
  y: 396,
  width: 842,
};

const SEGMENT_99043_text_value_2 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99043_text_2: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99043_text_value_2,
  x: -563,
  y: 541,
  width: 842,
};

const SEGMENT_99044_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99044_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99044_text_value_1,
  x: -343,
  y: 48,
  width: 842,
};

const SEGMENT_99044_text_value_2 = '{{heroName}}{{kidstitle}}「そこにレールや';

export const SEGMENT_99044_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99044_text_value_2,
  x: 75,
  y: 396,
};

const SEGMENT_99045_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99045_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99045_text_value_1,
  x: -600,
  y: 113,
  width: 842,
};

const SEGMENT_99047_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99047_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99047_text_value_1,
  x: -676,
  y: 84,
  width: 842,
};

const SEGMENT_99047_text_value_2 =
  'そのとき、{{heroName}}{{kidstitle}}がいいました。';

export const SEGMENT_99047_text_2: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99047_text_value_2,
  x: 387,
  y: 437,
  width: 842,
};

const SEGMENT_99048_text_value_1 =
  '{{heroName}}{{kidstitle}}は\n' + 'ひらめきました。';

export const SEGMENT_99048_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99048_text_value_1,
  x: 39,
  y: 460,
  width: 842,
};

const SEGMENT_99049_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99049_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99049_text_value_1,
  x: -652,
  y: 91,
  width: 842,
};

const SEGMENT_99049_text_value_2 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99049_text_2: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99049_text_value_2,
  x: -224,
  y: 479,
  width: 842,
};

const SEGMENT_99053_text_value_1 = '{{heroName}}{{kidstitle}}';

export const SEGMENT_99053_text_1: TextElement = {
  align: 'right',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99053_text_value_1,
  x: -612,
  y: 74,
  width: 842,
};

const SEGMENT_99054_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_99054_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99054_text_value_1,
  x: 300,
  y: 391,
  width: 842,
};

const SEGMENT_99056_text_value_1 = '{{heroName}}{{kidstitle}}のおかげです！';

export const SEGMENT_99056_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99056_text_value_1,
  x: 516,
  y: 54,
  width: 842,
};

const SEGMENT_99059_text_value_1 = '{{heroName}}{{kidstitle}}もにっこり。';

export const SEGMENT_99059_text_1: TextElement = {
  align: 'center',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99059_text_value_1,
  x: 112,
  y: 540,
  width: 322,
};

const SEGMENT_99060_text_value_1 = '{{heroName}}{{kidstitle}}。';

export const SEGMENT_99060_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99060_text_value_1,
  x: 604,
  y: 483,
  width: 842,
};

const SEGMENT_99061_text_value_1 =
  '{{heroName}}{{kidstitle}}もほこらしげです。';

export const SEGMENT_99061_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99061_text_value_1,
  x: 124,
  y: 174,
  width: 842,
};

const SEGMENT_99062_text_value_1 = 'と、{{heroName}}{{kidstitle}}。';

export const SEGMENT_99062_text_1: TextElement = {
  align: 'left',
  style: APJapanesefont_000000_21,
  text: SEGMENT_99062_text_value_1,
  x: 87,
  y: 127,
  width: 842,
};
